import testimonial_img_1 from "../../assets/images/testimonial/testimonial-1.jpg"
import testimonial_img_2 from "../../assets/images/testimonial/testimonial-2.jpg"
import testimonial_img_3 from "../../assets/images/testimonial/testimonial-3.jpg"
import testimonial_img_4 from "../../assets/images/testimonial/testimonial-4.jpg"
import testimonial_img_5 from "../../assets/images/testimonial/testimonial-5.jpg"
import testimonial_img_6 from "../../assets/images/testimonial/testimonial-6.jpg"
export const testimonialData = [
    {
        id: 1,
        name: "Pamela Downs",
        position: "Developer",
        src: testimonial_img_1,
        rating: 5,
        review: `“This involves outsourcing some or all of a company's safety potency
                to a service provider. Services may include security monitoring, incident
                response, and managing security devices and systems. And how to
                respond to security incidents."`
    },
    {
        id: 2,
        name: "Pamela Downs",
        position: "Developer",
        src: testimonial_img_2,
        rating: 5,
        review: `“This involves outsourcing some or all of a company's safety potency
                to a service provider. Services may include security monitoring, incident
                response, and managing security devices and systems. And how to
                respond to security incidents."`
    },
    {
        id: 3,
        name: "Pamela Downs",
        position: "Developer",
        src: testimonial_img_3,
        rating: 3.5,
        review: `“This involves outsourcing some or all of a company's safety potency
                to a service provider. Services may include security monitoring, incident
                response, and managing security devices and systems. And how to
                respond to security incidents."`
    },
    {
        id: 4,
        name: "Gregory Hays",
        position: "Developer",
        src: testimonial_img_4,
        rating: 4,
        review: `“This involves outsourcing some or all of a company's safety potency
                to a service provider. Services may include security monitoring, incident
                response, and managing security devices and systems. And how to
                respond to security incidents."`
    },
    {
        id: 5,
        name: "Howard Joly",
        position: "Developer",
        src: testimonial_img_5,
        rating: 4,
        review: `“This involves outsourcing some or all of a company's safety potency
                to a service provider. Services may include security monitoring, incident
                response, and managing security devices and systems. And how to
                respond to security incidents."`
    },
    {
        id: 6,
        name: "Andre Webber",
        position: "Developer",
        src: testimonial_img_6,
        rating: 4,
        review: `“This involves outsourcing some or all of a company's safety potency
                to a service provider. Services may include security monitoring, incident
                response, and managing security devices and systems. And how to
                respond to security incidents."`
    },

]